module.exports = __webpack_public_path__ + "img/img-licitacao.d063bda2.svg";